import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RetailerDetails from '../../components/blocks/RetailerDetails';
import Spinner from '../../components/common/Spinner';
import { putPermissions } from '../../store/actions/permissions';
import { postRetailerErpId, updateShipperAccount } from '../../store/actions/retailer';
import { createShopifyAccount } from '../../store/actions/api/shopify';
import { getWarehouses } from '../../store/actions/warehouses';
import { createWoocommerceCustomerAccount } from '../../store/actions/api/woocommerce';
import { updateAccountIdConfig } from '../../store/actions/accountId';
import { useFlagsmith } from 'flagsmith-react';
import { suppliersWhoShouldUseAccountIdConfigModal } from '../../constants/featureFlag';
import { isEmpty } from 'lodash';

function RetailerDetailsContainer(props) {
  const { retailer, isLoading, supplierId, getWarehouses } = props;
  const { getValue } = useFlagsmith();

  const shouldUseAccountIdConfigModal = shouldSupplierUseAccountIdConfigModal(
    getValue(suppliersWhoShouldUseAccountIdConfigModal),
    supplierId,
  );

  useEffect(() => {
    getWarehouses();
  }, [getWarehouses, supplierId]);

  if (isLoading || !retailer || !retailer.id) {
    return <Spinner />;
  }

  return <RetailerDetails {...props} shouldUseAccountIdConfigModal={shouldUseAccountIdConfigModal} key={retailer.id} />;
}

const mapStateToProps = ({ retailer, role, warehouses: supplierWarehouses, shopify, woocommerce, accountIdConfig }) => {
  const { isLoading, current, warehouses } = retailer;
  const { shopifyCustomerAccountId } = shopify;
  const { woocommerceCustomerAccountId } = woocommerce;
  const {
    retailer: currentRetailer,
    inventory_buffer,
    max_inventory_visible,
    approved_warehouses,
    retailer_id_in_source,
    account_id_types,
    replenishment_shipper_account,
    replenishment_shipper_account_type,
    account_id_config: currentAccountIdConfig,
  } = current;

  return {
    retailer: currentRetailer,
    buffer: inventory_buffer,
    warehouses,
    approved_warehouses,
    retailer_id_in_source,
    account_id_types,
    replenishment_shipper_account,
    replenishment_shipper_account_type,
    max_inventory_visible,
    isLoading,
    userRole: role.roles.role,
    supplierId: role.supplierId,
    supplierWarehouses: supplierWarehouses.data,
    shopifyCustomerAccountId,
    woocommerceCustomerAccountId,
    accountIdConfig: !isEmpty(accountIdConfig.data?.account_id_config)
      ? accountIdConfig.data.account_id_config
      : currentAccountIdConfig,
  };
};

const mapDispatchToProps = (dispatch) => ({
  putPermissions: (id, data) => dispatch(putPermissions(id, data)),
  saveErpId: (data, id) => dispatch(postRetailerErpId(data, id)),
  updateShipperAccount: (data) => dispatch(updateShipperAccount(data)),
  createShopifyAccount: (customerName, warehouseId) => dispatch(createShopifyAccount(customerName, warehouseId)),
  updateAccountIdConfig: ({ supplierId, retailerId, data }) =>
    dispatch(updateAccountIdConfig({ supplierId, retailerId, accountIdConfig: data })),
  createWoocommerceCustomerAccount: (customerUserName, supplierId, retailerId) =>
    dispatch(createWoocommerceCustomerAccount(customerUserName, supplierId, retailerId)),
  getWarehouses: () => dispatch(getWarehouses()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailerDetailsContainer);

RetailerDetailsContainer.propTypes = {
  retailer: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
};

function shouldSupplierUseAccountIdConfigModal(permittedSupplierIdsFromFlagsmith, supplierId) {
  try {
    const permittedSupplierIds = JSON.parse(permittedSupplierIdsFromFlagsmith);
    return permittedSupplierIds.includes(supplierId);
  } catch (error) {
    console.warn('Error checking if account id modal should be used', error);
    return false;
  }
}
